
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
//
// window.Vue = require('vue');
//
// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */
//
// Vue.component('example', require('./components/Example.vue'));
//
// const app = new Vue({
//     el: '#app'
// });

'use strict';


// Dependencies

const lightbox = require('lightbox2');


// Custom Modules

import ReportHistoryCategorySelect from './reports/select-history-category';
import ReportHistoryPlaceSelect from './reports/select-history-place';

import ReportNatureCategorySelect from './reports/select-nature-category';
import ReportNaturePlaceSelect from './reports/select-nature-place';

import ReportArcheologyPlaceSelect from './reports/select-archeology-place';

import SearchMap from './search/search-map';
import SearchMapNotification from './search/search-map-notification';

import SearchPanel from './search/search-panel';
import SearchForm from './search/search-panel-form'; 
import SearchPanelLegend from './search/search-panel-legend';
